
export enum PersonIdsEnum {
  emin,
  daniil,
  sasha,
  regina,
  anna,
  vlad,
};

export interface PersonInterface {
  id: PersonIdsEnum;
  name: string;
  company?: string;
  position: string[];
  avatarUrl: string;
  maulImageUrl: string;
}

export const PERSONS: Record<PersonIdsEnum, PersonInterface> = {
  [PersonIdsEnum.emin]: {
    id: PersonIdsEnum.emin,
    name: 'Эмин Алиев',
    company: 'Meta',
    position: [
      'Сlient partner Meta',
    ],
    avatarUrl: '/images/avatars/1.png',
    maulImageUrl: '/images/people/1.png',
  },
  [PersonIdsEnum.daniil]: {
    id: PersonIdsEnum.daniil,
    name: 'Даниил Шулейко',
    company: '«Яндекс»',
    position: [
      'Глава бизнес-группы Яндекса по электронной торговле и логистическим сервисам',
    ],
    avatarUrl: '/images/avatars/2.png',
    maulImageUrl: '/images/people/2.png',
  },
  [PersonIdsEnum.sasha]: {
    id: PersonIdsEnum.sasha,
    name: 'Александр Полесский',
    company: 'Meta',
    position: [
      'Client partner Meta',
    ],
    avatarUrl: '/images/avatars/3.png',
    maulImageUrl: '/images/people/3.png',
  },
  [PersonIdsEnum.regina]: {
    id: PersonIdsEnum.regina,
    name: 'Регина Кузьмина',
    company: 'Unilever',
    position: [
      'Президент группы компаний Unilever в России, Украине и Белоруссии',
    ],
    avatarUrl: '/images/avatars/4.png',
    maulImageUrl: '/images/people/4.png',
  },
  [PersonIdsEnum.anna]: {
    id: PersonIdsEnum.anna,
    name: 'Анна-Мария Тренева',
    company: 'Meta',
    position: [
      'Глава Meta в России',
    ],
    avatarUrl: '/images/avatars/5.png',
    maulImageUrl: '/images/people/5.png',
  },
  [PersonIdsEnum.vlad]: {
    id: PersonIdsEnum.vlad,
    name: 'Владислав Крейнин',
    company: '«Сбер»',
    position: [
      'старший вице-президент, директор департамента маркетинга и коммуникаций Сбера',
    ],
    avatarUrl: '/images/avatars/6.png',
    maulImageUrl: '/images/people/6.png',
  },
};
